import * as React from "react";
import { BRAND_SECONDARY_RGB } from "~/brandColors";

interface SadFaceIconProps {
  /**
   * Icon colour (defaults to BRAND_SECONDARY_RGB)
   */
  color?: string;
  /**
   * Width of the svg (default 132)
   */
  width?: number | string;
  /**
   * Height of the svg (default 132)
   */
  height?: number | string;
  className?: string;
}

/**
 * Sad face icon previously loaded from `iconSadFace.svg`.
 * Now rendered as inline SVG so the colour can be controlled via the `color` prop or CSS `color`.
 */
const SadFaceIcon: React.FC<SadFaceIconProps> = ({
  color = BRAND_SECONDARY_RGB,
  width = 132,
  height = 132,
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 132 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M89.5631 57.5504C92.0548 57.5504 94.1673 56.7108 95.9006 55.0316C97.634 53.3525 98.5006 51.2129 98.5006 48.6129C98.5006 46.0129 97.661 43.8733 95.9819 42.1941C94.3027 40.515 92.1631 39.6754 89.5631 39.6754C86.9631 39.6754 84.7965 40.515 83.0631 42.1941C81.3298 43.8733 80.4631 46.0129 80.4631 48.6129C80.4631 51.2129 81.3298 53.3525 83.0631 55.0316C84.7965 56.7108 86.9631 57.5504 89.5631 57.5504ZM42.4381 57.5504C45.0381 57.5504 47.2048 56.7108 48.9381 55.0316C50.6715 53.3525 51.5381 51.2129 51.5381 48.6129C51.5381 46.0129 50.6715 43.8733 48.9381 42.1941C47.2048 40.515 45.0381 39.6754 42.4381 39.6754C39.9465 39.6754 37.834 40.515 36.1006 42.1941C34.3673 43.8733 33.5006 46.0129 33.5006 48.6129C33.5006 51.2129 34.3402 53.3525 36.0194 55.0316C37.6985 56.7108 39.8381 57.5504 42.4381 57.5504ZM66.0006 131.975C56.9006 131.975 48.3423 130.242 40.3256 126.775C32.309 123.309 25.3215 118.596 19.3631 112.638C13.4048 106.68 8.6923 99.692 5.22564 91.6754C1.75897 83.6587 0.0256348 75.1004 0.0256348 66.0004C0.0256348 56.7921 1.75897 48.1796 5.22564 40.1629C8.6923 32.1462 13.4048 25.1858 19.3631 19.2816C25.3215 13.3775 32.309 8.69206 40.3256 5.22539C48.3423 1.75872 56.9006 0.0253906 66.0006 0.0253906C75.209 0.0253906 83.8215 1.75872 91.8381 5.22539C99.8548 8.69206 106.815 13.3775 112.719 19.2816C118.624 25.1858 123.309 32.1462 126.776 40.1629C130.242 48.1796 131.976 56.7921 131.976 66.0004C131.976 75.1004 130.242 83.6587 126.776 91.6754C123.309 99.692 118.624 106.68 112.719 112.638C106.815 118.596 99.8548 123.309 91.8381 126.775C83.8215 130.242 75.209 131.975 66.0006 131.975ZM66.0006 120.925C81.2756 120.925 94.2486 115.563 104.919 104.838C115.59 94.1129 120.926 81.1671 120.926 66.0004C120.926 50.7254 115.59 37.7525 104.919 27.0816C94.2486 16.4108 81.2756 11.0754 66.0006 11.0754C50.834 11.0754 37.8881 16.4108 27.1631 27.0816C16.4381 37.7525 11.0756 50.6712 11.0756 65.8379C11.0756 81.1129 16.4381 94.1129 27.1631 104.838C37.8881 115.563 50.834 120.925 66.0006 120.925ZM39.5131 97.6879C40.2715 97.6879 41.0569 97.4441 41.8694 96.9566C42.6819 96.4691 43.3048 95.9004 43.7381 95.2504C46.2298 91.7837 49.4798 89.1566 53.4881 87.3691C57.4965 85.5816 61.7215 84.6879 66.1631 84.6879C70.4965 84.6879 74.6402 85.6087 78.5944 87.4504C82.5486 89.2921 85.8256 91.9462 88.4256 95.4129C88.859 96.0629 89.509 96.6046 90.3756 97.0379C91.2423 97.4712 92.0006 97.6879 92.6506 97.6879C94.2756 97.6879 95.4131 97.0379 96.0631 95.7379C96.7131 94.4379 96.6048 93.0837 95.7381 91.6754C92.5965 86.9087 88.3985 83.1441 83.1444 80.3816C77.8902 77.6191 72.1756 76.2379 66.0006 76.2379C59.8256 76.2379 54.1381 77.592 48.9381 80.3004C43.7381 83.0087 39.7298 86.5295 36.9131 90.8629C35.7215 92.5962 35.4777 94.1671 36.1819 95.5754C36.8861 96.9837 37.9965 97.6879 39.5131 97.6879Z"
      fill={color}
    />
  </svg>
);

export default SadFaceIcon;
